import React, { useEffect, useRef } from "react";
// import noImage from "../data/images/no-image4.jpeg";
import { useNavigate, Link } from "react-router-dom";
// import { HashLink } from "react-router-hash-link";
import { useStateContext } from "../contexts/ContextProvider";
import { publicLinks, privateLinks } from "../data/dummyData";

import Button from "./Button";
import ManageAvatar from "./ManageAvatar";
import { HashLink } from "react-router-hash-link";
import SliderButton from "./SliderButton";
import { apiUpdateUser } from "../services/apiService";

const Sidebar = () => {
  const {
    activeMenu,
    setActiveMenu,
    isLoggedIn,
    user,
    handleLogout,
    leases,
    usersProperties,
    dualView,
  } = useStateContext();

  const navigate = useNavigate();

  const changeView = async () => {
    const userCopy = user;
    userCopy.defaultView =
      user.defaultView === "landlord" ? "tenant" : "landlord";
    const response = await apiUpdateUser(user.id, userCopy);
    if (response.hasError) {
      console.log(response.error.message);
    } else {
      console.log("User's view updated");
    }
  };

  let location;
  let links = isLoggedIn ? privateLinks : publicLinks;

  const normalLink =
    "flex w-80 items-center gap-2 pl-5 pt-3 pb-2.5 pr-20 rounded-lg text-md text-black hover:bg-black hover:text-white";

  const activeLink =
    "flex items-center gap-2 pl-5 pt-3 pb-2.5 rounded-lg text-snappily-orange text-md";

  if (isLoggedIn) {
    location = window.location.pathname;
  } else {
    location = window.location.hash;
  }

  const handleCloseSideBar = () => {
    setActiveMenu(false);
  };

  return (
    <>
      {activeMenu && (
        <>
          <div
            className="fixed top-0 left-0 sm:left-2/4 lg:left-2/3 right-0 bottom-0 bg-gray-100 mt-20
          overflow-y-auto overscroll-y-none z-40"
          >
            {isLoggedIn && (
              <div className="w-full my-5">
                {dualView && (
                  <div className="flex justify-center mt-5">
                    <div>Tenant View</div>
                    <SliderButton
                      type="tenantView"
                      value={user.defaultView}
                      customFunc={() => {
                        changeView();
                        handleCloseSideBar();
                        navigate("/onboarding-return");
                      }}
                    />
                  </div>
                )}
                <ManageAvatar />
                <div className="flex justify-center text-xl mt-5 capitalize">
                  Hi {user.firstName} 👋🏽
                </div>
                {user.defaultView === "landlord" && (
                  <div className="text-justified text-center px-10 mt-5">
                    You are currently managing
                    <span className="text-snappily-orange mx-1">
                      {usersProperties.length}
                    </span>
                    {usersProperties.length > 1
                      ? "properties, with"
                      : "property with"}
                    <span className="text-snappily-orange mx-1">
                      {leases.length}
                    </span>
                    roommates.
                  </div>
                )}
              </div>
            )}
            {links.map((item) => {
              return (
                <HashLink //use HashLink for #anchors
                  to={`${item.target}`}
                  key={item.id}
                  onClick={handleCloseSideBar}
                  className={location === item.target ? activeLink : normalLink}
                  style={{
                    backgroundColor:
                      location === item.target && !isLoggedIn ? "" : "",
                  }}
                >
                  {isLoggedIn ? item.icon : ""}
                  {item.name.replace(/-/g, " ").toUpperCase()}
                </HashLink>
              );
            })}

            {isLoggedIn ? (
              <div className="mt-16 bg-white border-gray-300 border-t-2 z-50">
                <div className="flex justify-center items-center h-20">
                  <div
                    className="text-2xl text-gray-500 hover:text-black cursor-pointer"
                    onClick={async () => {
                      await handleLogout();
                      navigate("/");
                    }}
                  >
                    Log out
                  </div>
                </div>
              </div>
            ) : (
              <div className="fixed bottom-0 left-0 sm:left-2/4 lg:left-2/3 right-0 bg-white border-gray-300 border-t-2 z-50">
                <div className="flex justify-center m-5">
                  <Button
                    background="bg-snappily-orange"
                    text="text-white"
                    opacity="bg-opacity-100"
                    title="Sign up"
                    height="h-10"
                    width="w-72"
                    borderHover="hover:border-snappily-green"
                    customFunc={() => {
                      navigate("/signup");
                      handleCloseSideBar();
                    }}
                  />
                </div>
                <div className="flex justify-center m-5">
                  <Button
                    background="bg-white"
                    text="text-snappily-orange"
                    opacity="bg-opacity-100"
                    title="Log in"
                    height="h-10"
                    width="w-72"
                    borderHover="hover:border-snappily-green"
                    customFunc={() => {
                      navigate("/login");
                      handleCloseSideBar();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
